// extracted by mini-css-extract-plugin
export default {"form":"Form_form__kUrdU","header":"Form_header__dEoB1","input":"Form_input__IH7Ud","link":"Form_link__mX4ES","buttonTest":"Form_buttonTest__Sjg9r","button":"Form_button__GLHLa"};